import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=bc2547c8"
import script from "./StudentEdit.vue?vue&type=script&lang=ts"
export * from "./StudentEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports